import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGridSection from './components/CategoryGridSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ArticleGridSection from './components/ArticleGridSection';
import CTASection from './components/CTASection';

const siteOrigin = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://itaobuy.baby';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet',
  url: siteOrigin,
  description: 'A powerful spreadsheet-based system designed to help users organize, analyze, and optimize their purchasing workflow with speed, clarity, and efficiency.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kaspreadsheet.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGridSection />
        <AboutSection />
        <FeaturesSection />
        <TestimonialsSection />
        <ArticleGridSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}